import "@/scripts/global/utils/LocalizationForm"
import "@/scripts/sections/FooterMenu.js"
import { formatMoney } from "@/scripts/global/utils/helpers"

import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import collapse from '@alpinejs/collapse'

import swiper from "@/scripts/components/swiper"
import klaviyo_newsletter from "@/scripts/sections/klaviyo-newsletter"
import accordion from "@/scripts/components/accordion"
import customer from "@/scripts/templates/customer/customer"
import backInStosk from "@/scripts/templates/product/backInStosk"
import splideSlider from "@/scripts/components/splide-slider";
import cart from "@/scripts/templates/cart/cart";

// Moved back to the global scope
import navigation from "@/scripts/sections/navigation";
import searchResult from "@/scripts/templates/search/search-results"



Alpine.plugin(focus)
Alpine.plugin(collapse)
window.Alpine = Alpine
window.formatMoney = formatMoney

document.addEventListener("alpine:init", () => {
  Alpine.data("swiper", swiper)
  Alpine.store("cart", cart())
  Alpine.data("klaviyo_newsletter", klaviyo_newsletter)
  Alpine.data("accordion", accordion)
  Alpine.data("customer", customer)
  Alpine.data("backInStosk", backInStosk)
  Alpine.data("splide", splideSlider)
  Alpine.data("searchResult", searchResult)
  Alpine.data("navigation", navigation);
})

Alpine.start()

